/**
 *  Currency formatter and replacer with locale support
 **/

export default class CurrencyTextUpdater {
  constructor(locale = $("html").attr("lang") || "en", currency = "USD") {
    this.formatter = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  update(target, amount) {
    if (!target || typeof target.textContent !== "string") return;

    const formattedAmount = this.formatter.format(amount);

    target.textContent = formattedAmount;
  }
}
